import { render, staticRenderFns } from "./PriorityNotificationDropdown.vue?vue&type=template&id=3e693a70&"
import script from "./PriorityNotificationDropdown.vue?vue&type=script&lang=js&"
export * from "./PriorityNotificationDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports